import { render, staticRenderFns } from "./IconUnlocked.vue?vue&type=template&id=b247703e&"
import script from "./IconUnlocked.vue?vue&type=script&lang=js&"
export * from "./IconUnlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports